
import { useDrawCard } from "@/stores/drawCard";
import { storeToRefs } from "pinia";
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const drawCards = useDrawCard();
    const { handString } = storeToRefs(drawCards);

    const draw = () => drawCards.draw();
    const judge = () => drawCards.judge();
    const reset = () => {
      drawCards.hand = ["", "", "", "", ""];
      drawCards.judgeResult = "";
    };

    let isIframe = false;
    if (window.parent !== window) isIframe = true;

    const close = () => {
      if (window.parent !== window) {
        const message = JSON.stringify({
          message: "CANCEL_MODAL",
        });
        window.parent.postMessage(message, "*");
      }
    };

    return {
      drawCards,
      handString,
      draw,
      judge,
      reset,
      isIframe,
      close,
    };
  },
});
